module.exports = __webpack_public_path__ + "img/sort.df0b7f6b.svg";